var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectWalletInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 10 2 C 10.414 2 10.75 2.336 10.75 2.75 L 10.75 10.25 C 10.75 10.664 10.414 11 10 11 C 9.586 11 9.25 10.664 9.25 10.25 L 9.25 2.75 C 9.25 2.336 9.586 2 10 2 Z M 5.404 4.343 C 5.696 4.636 5.696 5.11 5.404 5.403 C 3.545 7.262 2.989 10.058 3.995 12.487 C 5.001 14.916 7.371 16.499 10 16.499 C 12.629 16.499 14.999 14.916 16.005 12.487 C 17.011 10.058 16.455 7.262 14.596 5.403 C 14.395 5.216 14.313 4.934 14.381 4.669 C 14.448 4.403 14.656 4.195 14.922 4.128 C 15.187 4.06 15.469 4.142 15.656 4.343 C 17.944 6.631 18.629 10.072 17.391 13.061 C 16.152 16.051 13.235 18 10 18 C 6.764 18 3.847 16.051 2.608 13.061 C 1.37 10.072 2.055 6.631 4.343 4.343 C 4.636 4.051 5.11 4.051 5.403 4.343 Z",
    fill: "rgb(0, 0, 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectWalletInactive);
export default __webpack_public_path__ + "static/media/connectWalletInactive.0030a3f435c5956324372ca34d89757d.svg";
export { ForwardRef as ReactComponent };